import { LoggerService } from '../../utils/logger.service';
import { Injectable, ViewChild } from '@angular/core';
import { NativeMarket } from "@capacitor-community/native-market";
import { Capacitor } from "@capacitor/core";
import { ModulesManagerService } from '../Module/modules-manager.service';
import { VersionInfo } from 'src/app/interfaces/VersionInfo/version-info';
import { AppInfo } from 'src/app/interfaces/AppInfo/app-info';
import { Criticity } from 'src/app/enums/Criticity';

@Injectable({
  providedIn: 'root'
})


export class UpdaterService {
  private updateAlerte: any
  private appInfo: AppInfo;
  private manager: ModulesManagerService;
  private checkingForUpdates = false
  private presented = false
  constructor() {
  }

  get AppId() {
    return this.appInfo?.appId
  }

  get Platform() {
    if (this.manager.Tool.isPlatform("ios"))
      return "ios"
    if (this.manager.Tool.isPlatform("android"))
      return "android"
    return "web"
  }

  public async initiate(manager: ModulesManagerService) {
    this.manager = manager
  }

  public setPopupAlerte(updateAlerte: any) {
    this.updateAlerte = updateAlerte
  }

  private IsUpToDate() {
    if (!this.appInfo) return false
    let currentVersion = this.manager.Tool.getVersion()
    return !this.UpdateRequired(currentVersion, this.appInfo.latestVersion)
  }

  public IsUnderMaintenance() {
    if (!this.appInfo) return true
    return this.appInfo.underMaintenance
  }

  private IsLocked() {
    if (!this.appInfo) return true
    let currentVersion = this.manager.Tool.getVersion()
    if (currentVersion == "browser") return false
    for (const version of this.appInfo.versions)
      if (this.UpdateRequired(currentVersion, version.version, false) && version.lockApp) return true
  }


  get HigestCriticity(): Criticity {
    if (!this.appInfo) return Criticity.Fatal
    let maxCriticity = Criticity.Low
    if (this.manager.Tool.getVersion() == "browser") return maxCriticity
    for (const version of this.appInfo.versions)
      if (this.UpdateRequired(this.manager.Tool.getVersion(), version.version, false) && version.criticity > maxCriticity) maxCriticity = version.criticity

    return maxCriticity
  }

  private openMarket() {
    if (Capacitor.isNativePlatform()) {
      NativeMarket.openStoreListing({
        appId: this.AppId,
      });
    }
  }
  /**
   * 
   * @param current version that need to be compared (current version in user's device)
   * @param latest the target version ( current latest version in store)
   * @param egalOrHigher if true => 1.1.15 >= 1.1.15 else 1.1.15 > 1.1.15  ( here  we chose how to compare )
   * @return true if update is needed
   */
  public UpdateRequired(latest: string, current: string, egalOrHigher = false): boolean {
    const currentArr = current.split(".").map(Number);
    const latestArr = latest.split(".").map(Number);

    for (let i = 0; i < currentArr.length; i++) {
      if (currentArr[i] > latestArr[i]) {
        return true;
      } else if (currentArr[i] < latestArr[i]) {
        return false;
      }
    }

    return egalOrHigher;
  }

  // /**
  //  * 
  //  * @param latest version that need to be compared (current version in user's device)
  //  * @param current the target version ( current latest version in store)
  //  * @param egalOrHigher if true => 1.1.15 >= 1.1.15 else 1.1.15 > 1.1.15  ( here  we chose how to compare )
  //  * @return true if update is needed
  //  */
  // public UpdateRequired(latest: string, current: string, egalOrHigher = false): boolean {
  //   console.log(current + " > " + latest)
  //   let currentSplit = current.split(".")
  //   let latestSplit = latest.split(".")
  //   if (parseInt(currentSplit[0]) > parseInt(latestSplit[0])) {
  //     return true
  //   } else if (parseInt(currentSplit[0]) == parseInt(latestSplit[0])) {
  //     if (parseInt(currentSplit[1]) > parseInt(latestSplit[1])) {
  //       return true
  //     } else if (parseInt(currentSplit[1]) == parseInt(latestSplit[1])) {
  //       if ((parseInt(currentSplit[2]) > parseInt(latestSplit[2]) && egalOrHigher) || (!egalOrHigher && parseInt(currentSplit[2]) >= parseInt(latestSplit[2])))
  //         return true
  //     }
  //   }
  //   return false

  // }


  private promptForMaintenance() {
    let present = {
      header: this.manager.Trad.Parse("STR_UPDATER_TITLE_MAINTENANCE"),
      message: this.manager.Trad.Parse("STR_UPDATER_MSG_MAINTENANCE"),
      buttons: [
      ],
      cssClass: 'confirm-delete-alert',
      backdropDismiss: false,
      animated: true,
      translucent: true,
      keyboardClose: true,
    }
    this.updateAlerte.presentAlert(present)
    this.presented = true
  }

  private promptForUpdate(criticity: Criticity, BlockUi: boolean) {
    let title = ""
    let msg = ""

    switch (criticity) {
      case Criticity.Low:
        title = this.manager.Trad.Parse("STR_UPDATER_TITLE_LOW", { NextVersion: this.appInfo.latestVersion })
        msg = this.manager.Trad.Parse("STR_UPDATER_MSG_LOW")
        break;
      case Criticity.High:
        title = this.manager.Trad.Parse("STR_UPDATER_TITLE_HIGH", { NextVersion: this.appInfo.latestVersion })
        msg = this.manager.Trad.Parse("STR_UPDATER_MSG_HIGH")
        break;
    }
    let present: any = {
      header: title,
      message: msg,
      buttons: [],
      cssClass: 'confirm-delete-alert',
      backdropDismiss: !BlockUi,
      animated: true,
      translucent: true,
      keyboardClose: true,
    }
    if (!BlockUi) {
      present.buttons.push({
        text: this.manager.Trad.Parse("STR_CANCEL"),
        cssClass: 'button-cancel'
      })

    }

    present.buttons.push(
      {
        text: this.manager.Trad.Parse("STR_UPDATE"),
        handler: () => {
          this.openMarket();
          return !BlockUi
        }
      }
    )

    //this.updateAlerte.dismissAlert()
    this.updateAlerte.presentAlert(present)
    this.presented = true
  }

  public async checkForUpdates() {
    if (this.presented) return
    //if(this.Platform == "web") return  this.promptForUpdate(Criticity.High, true)
    if (this.checkingForUpdates) {
      while (this.checkingForUpdates) await this.manager.Tool.sleep(100)
      return
    }
    this.checkingForUpdates = true
    let url = await this.manager.Ws.LookUpUrl() + "/" + this.Platform + ".json"
    try {
      let data = await fetch(url).catch((e) => {
        LoggerService.error("UpdaterService fetch error:", e)
        return null
      })
      if (data?.status == 200)
        this.appInfo = await data?.json().catch((e) => { LoggerService.error("UpdaterService json parse error:", e); return null }) as AppInfo
    } catch (error) {
      LoggerService.error("UpdaterService general error:", error)
    }
    if (this.IsUnderMaintenance()) {
      LoggerService.log("UpdaterService maintenance check:", url, this.appInfo)
      this.promptForMaintenance()
      this.checkingForUpdates = false
      return; // locker l'appli ici
    }
    if (this.IsUpToDate()) {
      this.checkingForUpdates = false
      return; // ok on laisse passé
    }
    let Blocked = this.IsLocked()
    let currentCriticity = this.HigestCriticity
    if (currentCriticity == Criticity.Fatal) {
      this.checkingForUpdates = false
      return; // ok on laisse passé
    }
    this.promptForUpdate(currentCriticity, Blocked)
    this.checkingForUpdates = false

  }

}
